import { Directive, ElementRef, AfterViewInit, OnDestroy, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { HelpUseCase } from '@/app/_core/application/help/help.use-cases';

@Directive({
  selector: '[app-layout-subheader]',
  standalone: true
})
export class LayoutDirective implements AfterViewInit, OnDestroy {
  public readonly host = inject(ElementRef<HTMLElement>);
  public readonly helpUseCases = inject(HelpUseCase);
  private readonly platformId = inject(PLATFORM_ID);

  private resizeObserver!: ResizeObserver;

  ngAfterViewInit(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    const update = () => {
      const rect = this.host.nativeElement.getBoundingClientRect();
      const rootStyle = document.documentElement.style;
      rootStyle.setProperty('--pane-top', rect.top + 15 + 'px');
      rootStyle.setProperty('--pane-left', rect.left + 'px');
      rootStyle.setProperty('--pane-width', rect.width + 'px');
    };
    update();
    this.resizeObserver = new ResizeObserver(update);
    this.resizeObserver.observe(this.host.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }
}
